import { render, staticRenderFns } from "./IDL.vue?vue&type=template&id=dfe1a18a&scoped=true"
import script from "./IDL.vue?vue&type=script&lang=js"
export * from "./IDL.vue?vue&type=script&lang=js"
import style0 from "./IDL.vue?vue&type=style&index=0&id=dfe1a18a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe1a18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfe1a18a')) {
      api.createRecord('dfe1a18a', component.options)
    } else {
      api.reload('dfe1a18a', component.options)
    }
    module.hot.accept("./IDL.vue?vue&type=template&id=dfe1a18a&scoped=true", function () {
      api.rerender('dfe1a18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/Candidate/Resume/IDL.vue"
export default component.exports